interface UploadResponse {
  signedUrl: string
  publicUrl: string
  fileName: string
}

const JWT_SECRET = process.env.NEXT_PUBLIC_MENU_JWT_SECRET

// Create JWT token
async function getAuthToken(): Promise<string> {
  const response = await fetch('/api/auth/menuTokenGenerator', {
    method: 'POST',
  })

  if (!response.ok) {
    throw new Error('Failed to get auth token')
  }

  const { token } = await response.json()
  return token
}

export async function uploadToGCS(file: File, userEmail: string): Promise<string> {
  try {
    const authToken = await getAuthToken()
    const contentType = file.type.toLowerCase()

    console.log('Uploading file:', file.name)
    console.log('Content-Type:', contentType)

    // Get signed URL
    const signedUrlResponse = await fetch(
      process.env.NEXT_PUBLIC_UPLOAD_FUNCTION_URL ??
        'https://generate-signed-url-871575435168.us-east4.run.app',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
          'X-User-Email': userEmail,
        },
        body: JSON.stringify({
          fileName: file.name,
          contentType,
          fileSize: file.size,
        }),
      },
    )

    if (!signedUrlResponse.ok) {
      const error = await signedUrlResponse.json()
      console.error('Signed URL error:', error)
      throw new Error(error.message || 'Failed to get signed URL')
    }

    const { signedUrl, publicUrl }: UploadResponse = await signedUrlResponse.json()

    console.log('Got signed URL:', `${signedUrl.substring(0, 100)}...`)
    console.log('Uploading to GCS...')

    // ✅ Upload with XMLHttpRequest to avoid fetch issues
    const uploadSuccess = await new Promise<boolean>((resolve, reject) => {
      const xhr = new XMLHttpRequest()

      xhr.open('PUT', signedUrl, true)
      // Don't set any headers - let the browser handle it

      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(true)
        } else {
          reject(
            new Error(`Upload failed with status: ${xhr.status}, response: ${xhr.responseText}`),
          )
        }
      }

      xhr.onerror = () => {
        reject(new Error('Network error during upload'))
      }

      xhr.send(file)
    })

    if (!uploadSuccess) {
      throw new Error('Upload failed')
    }

    console.log('Upload successful!')
    return publicUrl
  } catch (error) {
    console.error('Upload error:', error)
    throw error
  }
}
